module.exports = __webpack_public_path__ + "assets_app/img/header_home.515f188e.svg";